import React, { useState, useEffect } from 'react';
import { isNil } from 'lodash';
import { selectOutputVersionOptions, selectSquashedOutputVersionOptions } from '../../../redux/selectors/orderPlacementSelectors';
import VersionSelect from '../VersionSelect';
import { getOutputVersionOptions, getSquashedOutputVersionOptions } from '../../../redux/slices/orderPlacementSlice';
import { TitleEntity } from '../../../redux/slices/slice_types';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

interface OutputVersionSelectProps {
  value: number;
  onChange: (e: any) => void;
  titleId?: number;
  label: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  id?: string;
  disabled?: boolean;
  squashed?: boolean;
}

const OutputVersionSelect = ({
  value,
  onChange,
  titleId,
  label,
  required,
  error,
  helperText,
  id,
  disabled,
  squashed = false
}: OutputVersionSelectProps) => {
  const dispatch = useAppDispatch();
  const outputVersionOptions = useAppSelector(selectOutputVersionOptions);
  const squashedOutputVersionOptions = useAppSelector(selectSquashedOutputVersionOptions);
  const [loading, setLocalizedLoading] = useState(false);
  const [versions, setVersions] = useState<number[]>([]);

  useEffect(() => {
    if (!titleId) return;

    if (squashedOutputVersionOptions[titleId]) {
      return setVersions(squashedOutputVersionOptions[titleId]);
    }

    setLocalizedLoading(true);
    if (squashed) {
      dispatch(getSquashedOutputVersionOptions(Number(titleId)))
        .unwrap()
        .then(({ versions }) => {
          setVersions(versions);
        })
        .finally(() => {
          setLocalizedLoading(false);
        });
    } else {
      dispatch(getOutputVersionOptions(Number(titleId)))
        .unwrap()
        .finally(() => {
          setLocalizedLoading(false);
        });
    }
  }, [titleId, squashed]);

  let outputDropdownOptions: TitleEntity[] = [];

  if (titleId) {
    outputDropdownOptions = outputVersionOptions?.[titleId] || [];
  }

  let options = outputDropdownOptions.map((option: TitleEntity) => option.id || option.piece_id || option.alternate_name);
  options = [...new Set(options)].filter((x) => !isNil(x));
  return (
    <div>
      <VersionSelect
        id={id}
        value={value}
        options={squashed ? versions : options}
        onChange={onChange}
        forceEnableOptions
        label={loading ? 'Loading...' : label}
        required={required}
        error={error}
        helperText={helperText}
        disabled={loading || disabled}
      />
    </div>
  );
};
export default OutputVersionSelect;
